import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Cross-Platform Delivery", desc: "Mobile builds that balance speed, quality, and long-term maintainability across devices." },
  { title: "Native-Feeling UX", desc: "Interaction patterns that feel deliberate on mobile instead of squeezed down from desktop thinking." },
  { title: "Backend Integration", desc: "Clean connections into CRM, ERP, APIs, payments, authentication, and internal systems." },
  { title: "Push & Messaging", desc: "Notification flows that support activation, retention, reminders, and transactional updates." },
  { title: "Store Launch Support", desc: "Release preparation, asset packaging, and submission guidance for app-store deployment." },
  { title: "Post-Launch Analytics", desc: "Event tracking and product signals that help the team improve after launch instead of guessing." },
];

const MobileApps = () => (
  <StitchFeaturePage
    label="MOBILE APP DEVELOPMENT"
    title="Mobile products"
    titleAccent="that ship well."
    subtitle="Thoughtful mobile experiences connected to the systems your business already depends on."
    features={features}
    ctaLabel="PLAN YOUR MOBILE APP"
  />
);

export default MobileApps;
